document.addEventListener("DOMContentLoaded", () => {
    function getCurrentProductHandle(root) {
      const fromDom = root?.getAttribute?.("data-current-product-handle") || "";
      if (fromDom) return fromDom.trim();
      const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : "";
    }

    function bringCurrentLandingColumnFirst(tableBox) {
      const currentHandle = getCurrentProductHandle(tableBox);
      if (!currentHandle) return;

      const rows = tableBox.querySelectorAll(
        ".product-img-lists, .attribute-value-lists, .content-image-lists"
      );

      rows.forEach((row) => {
        const cells = [...row.children].filter((el) => el.hasAttribute("data-product-handle"));
        const currentCell = cells.find(
          (el) => el.getAttribute("data-product-handle") === currentHandle
        );
        if (!currentCell || cells[0] === currentCell) return;
        cells[0].before(currentCell);
      });
    }

    document.querySelectorAll(".steamer-comparison-table-box").forEach(bringCurrentLandingColumnFirst);
    document.addEventListener("shopify:section:load", () => {
      document.querySelectorAll(".steamer-comparison-table-box").forEach(bringCurrentLandingColumnFirst);
    });

    function contentScrolling(className) {
      const scrollContainer = document.querySelector(className);
      if (!scrollContainer) return;

      let isDown = false;
      let startX;
      let scrollLeft;
  
      scrollContainer.addEventListener("mousedown", (e) => {
        isDown = true;
        scrollContainer.classList.add("active");
        startX = e.pageX - scrollContainer.offsetLeft;
        scrollLeft = scrollContainer.scrollLeft;
      });
  
      scrollContainer.addEventListener("mouseleave", () => {
        isDown = false;
        scrollContainer.classList.remove("active");
      });
  
      scrollContainer.addEventListener("mouseup", () => {
        isDown = false;
        scrollContainer.classList.remove("active");
      });
  
      scrollContainer.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollContainer.offsetLeft;
        const walk = (x - startX) * 3;
        scrollContainer.scrollLeft = scrollLeft - walk;
      });
    }
  
    contentScrolling(".steamer-comparison-table-box");
  });
  